import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
import { EnvironmentVariablesService } from './app/core/services/environment-variables.service';
import { APP_INITIALIZER, inject } from '@angular/core';

registerLocaleData(localeEsCo);
// 🔹 Función para inicializar variables de entorno antes de arrancar la app
export function initializeApp(envService: EnvironmentVariablesService) {
  return () => envService.loadConfig().toPromise();
}

// 🔹 Agregar el `APP_INITIALIZER` en la configuración de la app
const extendedAppConfig = {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    {
      provide: APP_INITIALIZER,
      useFactory: () => initializeApp(inject(EnvironmentVariablesService)),
      deps: [EnvironmentVariablesService],
      multi: true,
    },
  ],
};

// 🔹 Inicializar la aplicación con la configuración extendida
bootstrapApplication(AppComponent, extendedAppConfig).catch((err) =>
  console.error(err)
);
